import React from 'react';
import {Switch, Route} from 'react-router-dom';
import ErrorBoundary from '@/ErrorBoundary';
// import {vendorB4login, vendorB2cCss} from '@/config';
import {appBaseName} from '@/config';

import Header from '@/views/Layout/Public/Header';
import Footer from '@/views/Layout/Public/Footer';

import Login from '@/views/Login';
import Logout from '@/views/Logout';
import Activation from '@/views/Activation';
import Registration from '@/views/Activation/Registration';
import ForgetPassword from '@/views/ForgetPassword';
import ForgetPasswordB2b from '@/views/ForgetPasswordB2b';
import ResetPassword from '@/views/ForgetPassword/ResetPassword';
import Error404 from '@/Error404';

const LoginPage = ({match}) => (
  <>
    <link
      rel='stylesheet'
      href={`${appBaseName}/assets/css/login.css?timestamp=${new Date().getTime()}`}
    />
    <ErrorBoundary>
      <main className='container'>
        <Switch>
          <Route path={`${match.path}`} component={Login} />
        </Switch>
      </main>
    </ErrorBoundary>
  </>
);

const Public = ({match}) => (
  <>
    <link rel='stylesheet' href={`${appBaseName}/assets/css/b2c_base.css`} />
    <Header />
    <ErrorBoundary>
      <main className='container'>
        <Switch>
          <Route path={`${match.path}/activation`} component={Activation} />
          <Route path={`${match.path}/registration`} component={Registration} />
          <Route
            path={`${match.path}/forget_password`}
            component={ForgetPassword}
          />
          <Route
            path={`${match.path}/forget_password_b2b`}
            component={ForgetPasswordB2b}
          />
          <Route
            path={`${match.path}/reset_password`}
            component={ResetPassword}
          />
          <Route path={`${match.path}/logout`} component={Logout} />
          <Route path='*' component={Error404} />
        </Switch>
      </main>
    </ErrorBoundary>
    <Footer />
  </>
);
export {LoginPage, Public};
